var map = {
	"./bank-transfer.svg": 1682,
	"./betnearn-ico.svg": 1683,
	"./birthday-bonus-ico.svg": 1684,
	"./birthday.svg": 1685,
	"./bonus-code-ico.svg": 1686,
	"./bonus-ico.svg": 1687,
	"./bonus-received-ico.svg": 1688,
	"./bonus.svg": 1689,
	"./business-account-upgrade-ico.svg": 1690,
	"./check-in-daily-ico.svg": 1691,
	"./checked.svg": 1692,
	"./cloud-pointer.svg": 1693,
	"./crypto.svg": 1694,
	"./daily-bonus-ico.svg": 1695,
	"./daily-limit.svg": 1696,
	"./deposit-delay-bonus-ico.svg": 1697,
	"./e-wallet.svg": 1698,
	"./earn-x33-coin-ico.svg": 1699,
	"./email.svg": 1700,
	"./facebook.svg": 1701,
	"./feedback.svg": 1702,
	"./first-bet-ico.svg": 1703,
	"./games-rebate-ico.svg": 1704,
	"./info.svg": 1705,
	"./instagram.svg": 1706,
	"./live-casino-rebate-ico.svg": 1707,
	"./lucky-spin-ico.svg": 1708,
	"./messenger.svg": 1709,
	"./mobile-app-deposit-ico.svg": 1710,
	"./monthly-cash.svg": 1711,
	"./msg-activity.svg": 1712,
	"./msg-ann.svg": 1713,
	"./msg-notice.svg": 1714,
	"./new-icon.svg": 1715,
	"./people-ico.svg": 1716,
	"./quick-pay.svg": 1717,
	"./rescue-bonus-ico.svg": 1718,
	"./rescue-lc-ico.svg": 1719,
	"./rescue-slots-ico.svg": 1720,
	"./return.svg": 1721,
	"./sc-bc-active-ico.svg": 1722,
	"./sc-bc-ico.svg": 1723,
	"./sc-bi-active-ico.svg": 1724,
	"./sc-bi-ico.svg": 1725,
	"./sc-mail-active-ico.svg": 1726,
	"./sc-mail-ico.svg": 1727,
	"./sc-mp-active-ico.svg": 1728,
	"./sc-mp-ico.svg": 1729,
	"./sc-pin-active-ico.svg": 1730,
	"./sc-pin-ico.svg": 1731,
	"./slots-rebate-ico.svg": 1732,
	"./sports-rebate-ico.svg": 1733,
	"./telegram.svg": 1734,
	"./twitter.svg": 1735,
	"./vip-up-level-ico.svg": 1736,
	"./vip-weekly-bonus.svg": 1737,
	"./wallet-balance-interest-ico.svg": 1738,
	"./wallet-ico.svg": 1739,
	"./weekly-tournament-ico.svg": 1740,
	"./welcome-bonus-ico.svg": 1741,
	"./whatsapp.svg": 1742,
	"./withdrawal-delay-bonus-ico.svg": 1743,
	"./withdrawal.svg": 1744,
	"./x33-coin.svg": 1745
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;